import initialStateSubscribable from '@/shared/mixins/store/subscribableData/initialState';

import { Sen4State } from './types';

export default function initialState(): Sen4State {
  return {
    ...initialStateSubscribable(),
  };
}
